import type { TabsItem } from '@nuxt/ui'

export const SCHOOL_TABS: TabsItem[] = [
  {
    value: 'index',
    label: 'О школе',
  },
  {
    value: 'directions',
    label: 'Направления',
  },
  { value: 'schedule', label: 'Расписание' },
  {
    value: 'trainers',
    label: 'Тренеры',
  },
  { value: 'our-pride', label: 'Наша гордость' },
  { value: 'news', label: 'Новости' },
  // { value: 'compmetitions', label: 'Соревнования' },
  { value: 'reviews', label: 'Отзывы' },
  { value: 'contacts', label: 'Контакты' },
]

export const MOCK_DESCRIPTION = `<p>Моковая Спортивная школа "Олимпийские надежды" предлагает уникальные программы для юных пловцов. Мы гордимся нашими тренерами, которые имеют опыт участия в международных соревнованиях. Наша цель — развивать таланты и готовить чемпионов, предоставляя лучшие условия для тренировок и соревнований.</p> <br /> <p>Мы стремимся развивать в наших учениках не только спортивные навыки, но и жизненные ценности. </p>`

export const MOCK_STUDENTS = [
  {
    name: 'Мокова Екатерина',
    image_url: 'https://picsum.photos/394/240?random=1',
    description:
      'Победитель международного соревнования по плаванию. Заняла первое место',
    trainer: {
      name: 'Моков Сергей Петрович',
    },
    directions: [
      {
        slug: 'football',
        name: 'Футбол',
      },
    ],
  },
  {
    name: 'Моков Михаил',
    image_url: 'https://picsum.photos/394/240?random=2',
    description:
      'Победитель международного соревнования по футболу. Заняла первое место',
    directions: [
      {
        slug: 'football',
        name: 'Футбол',
      },
    ],
    trainer: {
      name: 'Моков Сергей Петрович',
    },
  },
  {
    name: 'Мокова Екатерина2',
    image_url: 'https://picsum.photos/394/240?random=3',
    description:
      'Победитель международного соревнования по гимнастике. Заняла первое место',
    trainer: {
      name: 'Моков Сергей Петрович',
    },
    directions: [
      {
        slug: 'football',
        name: 'Футбол',
      },
    ],
  },
  {
    name: 'Мокова Евгения',
    image_url: 'https://picsum.photos/394/240?random=4',
    description:
      'Победитель международного соревнования по мокам. Заняла моковое место',
    trainer: {
      name: 'Моков Сергей Петрович',
    },
    directions: [
      {
        slug: 'football',
        name: 'Футбол',
      },
    ],
  },
]
